import { PlayType } from '@bbkAdminRedux/rtkq/play.slice';

export const DRAWER_ANIMATION_DURATION = 300;

export const getPlayTypeFromRoute = (
  type: string | undefined
): PlayType | null => {
  if (type === 'expansion') return PlayType.UPSELL;
  if (type === 'acquisition') return PlayType.ACQUISITION;
  if (type === 'retention') return PlayType.RETENTION;
  return null;
};

export const getRouteTypeFromPlayType = (type: string | undefined): string => {
  if (type === PlayType.UPSELL) return 'expansion';
  if (type === PlayType.ACQUISITION) return 'acquisition';
  if (type === PlayType.RETENTION || type === PlayType.CHURN_PREVENTION)
    return 'retention';
  return 'expansion';
};
